export default cameras => cameras.find(c => c.active === true)



// WEBPACK FOOTER //
// ./src/helpers/cameras/getCurrentCamera.js